// 只对当前公开内容做展示排序，不能改变请求目标、原次数或原资金快照。
export function predictionVisibleGroups(presentation) {
  if (!presentation || !Array.isArray(presentation.groups)) return null;
  return presentation.groups.filter(group => group && group.visible === true && typeof group.key === 'string' && Array.isArray(group.pages));
}

export function predictionDisplayPages(pages, presentation, selectedKey) {
  const groups = predictionVisibleGroups(presentation);
  if (!groups) return pages;
  const group = groups.find(row => row.key === selectedKey) || groups[0];
  if (!group) return [];
  const byKey = new Map(pages.map(page => [page.key, page]));
  return group.pages.flatMap(display => {
    const page = byKey.get(display.key);
    return page ? [{ ...page, imageUrl: display.imageUrl || page.imageUrl }] : [];
  });
}
